import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { clientConfigFn } from "clientConfig";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
export const VersionMenuItem = () => {
    const { showClientVersion } = clientConfigFn();
    const version = process.env.FORTIS_CAPITAL_CLIENT_VERSION;
    if (version === "" || showClientVersion === false) {
        return null;
    }
    return (_jsxs(ListItem, { title: `Version - ${version}`, children: [_jsx(ListItemIcon, { children: _jsx(InfoOutlinedIcon, {}) }), _jsx(ListItemText, { primary: "Version", secondary: version })] }));
};
